import React, {PureComponent} from "react"
import {TooltipRenderProps} from "react-joyride"

import Close from "@irati/ui/src/Close"
import Flex from "@irati/ui/src/Flex"
import Button from "@irati/ui/src/Button"
import {LangLoader, FormattedMessage, InjectIntl, injectIntl} from "@irati/utils/lang"
import {PLATFORM} from "@irati-web/app/src/routeConfig"

import {TourStep} from "../../index"
import {ToolTipContainer, ProgressCircle, RelaDiv} from "./styled"

interface Props extends TooltipRenderProps, InjectIntl {
  step: TourStep
}

class CustomToolTip extends PureComponent<Props> {
  render() {
    const {
      index: currentStepIndex,
      step: {Content},
      size,
      backProps,
      primaryProps,
      tooltipProps,
      isLastStep,
      closeProps
    } = this.props
    const isFirstStep = currentStepIndex === 0

    return (
      <ToolTipContainer {...tooltipProps}>
        <RelaDiv>
          <Close {...closeProps} />
        </RelaDiv>
        <LangLoader bucket={PLATFORM}>
          <Content />

          <Flex justifyContent="space-between" alignItems="center">
            <Flex justifyContent="center">
              {new Array(size).fill(0).map((_, index) => {
                return <ProgressCircle key={`tourStepProgressCircle(${index + 1}/${size})`} active={currentStepIndex === index} />
              })}
            </Flex>
            <Flex alignItems="center">
              {!isFirstStep && (
                <Button {...backProps} tertiary small marginRight={1}>
                  <FormattedMessage id="platform.tour.buttons.back" />
                </Button>
              )}
              {!isLastStep && (
                <Button {...primaryProps} primary small>
                  <FormattedMessage id="platform.tour.buttons.next" />
                </Button>
              )}
              {isLastStep && (
                <Button {...primaryProps} primary small>
                  <FormattedMessage id="platform.tour.buttons.finish" />
                </Button>
              )}
            </Flex>
          </Flex>
        </LangLoader>
      </ToolTipContainer>
    )
  }
}

export default injectIntl(CustomToolTip)
